import { WebInterfaceBaseState } from 'common/base/state';
import { connect } from 'react-redux';
import { IWebInterfaceAction } from '../../../../common/entities';
import { onClickProcessDetailTransaction } from '../../actions';
import ProcessDetails from '../../components/widgets/ProcessDetails';
import IProcessDetailsProps from '../../entities/widgets/ProcessDetailsProps';
import { getSelectedTileSelector } from '../../selectors/CountTileSelectors';
import { getLoadingProcessDetails } from '../../selectors/ProcessDetailsSelector';
import { getSelectedProcess } from '../../selectors/ProcessesSelectors';

// state to component properties
const mapStateToProps = function (
	state: WebInterfaceBaseState,
	props: IProcessDetailsProps
): IProcessDetailsProps {
	return {
		selectedProcess: getSelectedProcess(state),
		loading: getLoadingProcessDetails(state),
		category: getSelectedTileSelector(state)
	};
};

// components callbacks to store dispatcher
const mapDispatchToProps = function (dispatch: Function): IProcessDetailsProps {
	return {
		onClickItem: function (data: IWebInterfaceAction) {
			dispatch(onClickProcessDetailTransaction(data));
		}
	};
};

// react - redux connection
const ProcessDetailsContainer = connect(mapStateToProps, mapDispatchToProps)(ProcessDetails);

export default ProcessDetailsContainer;
